import { FormikProps } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NormalDatepicker } from 'src/components/mui-overrides/Datepicker';
import { object, string } from 'yup';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

/**
 * @deprecated for now, until we decided that fiscal month should be handled differently.
 * @param executionDate
 * @returns
 */
// const calculateEarningPeriod = (executionDate: string) => {
//   // return last month
//   let today = executionDate ? new Date(executionDate) : new Date();
//   // Last month or if January, last year december
//   today = moment(today).set('date', 15).add(-1, 'months').toDate();
//   const earningPeriod = today;
//   return earningPeriod.toISOString();
// };

export const validationSchemaEarningPeriod = object({
  earningsPeriod: string().optional(),
});

export const getInitValuesEarningPeriod = (executionDate: string) => {
  return {
    earningsPeriod: executionDate,
  };
};

export interface EarningPeriodValues {
  earningsPeriod: string;
}

interface Props {
  formik: FormikProps<EarningPeriodValues>;
}

export const EarningPeriod: FC<Props> = ({ formik }) => {
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid xs={3} sm={5} sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
        <Typography variant="body1">{t('issuer.rent.form.earningsPeriod')}</Typography>
      </Grid>
      <Grid>
        <form onSubmit={formik.handleSubmit}>
          <NormalDatepicker
            label={t('issuer.rent.form.earningsPeriod')}
            fieldName="earningsPeriod"
            formik={formik}
            ddmmyy={['month', 'year']}
            disabled={true}
          />
        </form>
      </Grid>
    </Grid>
  );
};
